import gql from 'graphql-tag';

export const remoteUserFragment = gql`
  fragment remoteUserFragment on RemoteUser {
    dokkioClass
    id
    accountID
    dokkioUserID
    remoteUserType
    remoteID
    firstName
    lastName
    displayName
    email
    imageURL
    rowCreatedAt
  }
`;
export default remoteUserFragment;
